import React from 'react';
const stats = [{
  value: '50+',
  label: 'Years in governance'
}, {
  value: '13',
  label: 'Chair & presidential roles'
}, {
  value: '400+',
  label: 'Trustees trained'
}];
export function ProfileHero() {
  return <header id="overview" aria-labelledby="overview-title" className="relative isolate flex min-h-screen scroll-mt-20 flex-col overflow-hidden bg-cream-dark pt-20" data-id="element-183" data-mp="3g3mrgolv6iql">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/96d1c6f5-3e19-4c6b-bd9f-7cd42348952b.jpg" alt="" className="absolute inset-0 -z-20 h-full w-full object-cover" data-id="element-184" data-mp="3q3n7o1ofsiqk" />
      <div className="absolute inset-0 -z-10 bg-cream-dark/70" aria-hidden="true" data-id="element-185" data-mp="2r2q794s9nhs" />

      <div className="mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-6 py-20 md:px-10 lg:px-[4.5rem]" data-id="element-186" data-mp="7nt6nxki2l3q">
        <p className="text-xs font-semibold uppercase tracking-[0.35em] text-white" data-id="element-187" data-mp="cpik1jv73auz">James “Jim” Godfrey OBE</p>

        <h1 id="overview-title" className="mt-8 max-w-5xl font-serif text-5xl font-bold leading-[1.08] text-white sm:text-6xl lg:text-7xl" data-id="element-188" data-mp="hnaae9g6yox2">
          Board leadership that shapes the future of global agriculture.
        </h1>

        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-white/75" data-id="element-189" data-mp="14m8f5zrdpfqh">
          Non-Executive Director and Board Chair with five decades of governance across public companies, public bodies
          and international research institutions — from Lincolnshire to the CGIAR network.
        </p>

        <div className="mt-10 flex flex-wrap gap-4" data-id="element-190" data-mp="1scb446zzy5kv">
          <a href="#board-experience" className="inline-flex items-center rounded-full bg-wheat px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] text-white transition-colors duration-150 hover:bg-wheat-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" data-id="element-191" data-mp="1sex9q13bub0g">
            Explore Board Experience
          </a>
          <a href="#contact" className="inline-flex items-center rounded-full border border-white/25 bg-cream-dark/60 px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] text-white backdrop-blur transition-colors duration-150 hover:bg-cream-dark/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" data-id="element-192" data-mp="2b9m4juxd751w">
            Get in Touch
          </a>
        </div>

        <dl className="mt-12 grid max-w-4xl gap-4 sm:grid-cols-3" data-id="element-193" data-mp="3mrrrm9j49j4q">
          {stats.map(s => <div key={s.label} className="flex flex-col-reverse rounded-2xl border border-white/15 bg-cream-dark/40 px-5 py-5 backdrop-blur-sm" data-id="element-194" data-mp="3rsxliaoijcfu">
              <dt className="mt-1 text-xs font-medium uppercase tracking-[0.14em] text-white/65" data-id="element-195" data-mp="3hswyadniwc6d">{s.label}</dt>
              <dd className="font-serif text-4xl text-white" data-id="element-196" data-mp="1b4bhu6uwwyi1">{s.value}</dd>
            </div>)}
        </dl>
      </div>

      <a href="#about" className="mx-auto mb-8 text-[0.68rem] font-semibold uppercase tracking-[0.35em] text-white/60 transition-colors duration-150 hover:text-white" data-id="element-197" data-mp="1g1k1kbvplale">
        Scroll to explore
      </a>
    </header>;
}